module.exports = __webpack_public_path__ + "img/academiaCeo.bf4c3d16.png";